import keyBy from 'lodash/keyBy';

export function makeTreeFromTags(contentTags) {
  const copyOfTags = JSON.parse(JSON.stringify(contentTags)).map((tag) => ({
    ...tag,
    children: [],
  }));

  const themesAndSubthemesMapById = keyBy(copyOfTags, '_id');

  for (const tag of copyOfTags) {
    const parentTag = themesAndSubthemesMapById[tag.parentId];
    if (parentTag) {
      parentTag.children.push(tag);
    }
  }

  return Object.values(themesAndSubthemesMapById).filter(
    (tag) => !tag.parentId || !themesAndSubthemesMapById[tag.parentId]
  );
}

export function makeTreeToRootFromTags(contentTags, contentTagsMapById) {
  const copyOfTags = JSON.parse(JSON.stringify(contentTags)).map((tag) => ({
    ...tag,
    children: [],
  }));

  const themesAndSubthemesMapById = keyBy(copyOfTags, '_id');

  for (const tag of copyOfTags) {
    let parentTag = themesAndSubthemesMapById[tag.parentId];

    if (!parentTag && contentTagsMapById[tag.parentId]) {
      parentTag = {
        ...contentTagsMapById[tag.parentId],
        children: [],
      };

      themesAndSubthemesMapById[tag.parentId] = parentTag;
    }

    if (parentTag) {
      parentTag.children.push(tag);
    }
  }

  return Object.values(themesAndSubthemesMapById).filter(
    (tag) => !tag.parentId || !themesAndSubthemesMapById[tag.parentId]
  );
}
